
































import OrderRoutePickup from '@/components/new-design/order-common/OrderRoutePickup.vue'
import OrderRouteDropoff from '@/components/new-design/order-common/OrderRouteDropoff.vue'
import OrderDistance from '@/components/order-common/OrderDistance.vue'

export default {
  components: { OrderRoutePickup, OrderRouteDropoff, OrderDistance },
  props: {
    multiStop: { type: Object, required: true },
    order: { type: Object, default: null }
  }
}
